export const ALLOW_COMPRESSED_FILES = ["zip", "gz", "tar", "rar"];

export const ALLOW_VIDEO = ["mp4", "mov", "avi", "hevc", "mkv"];

export const ALLOW_IMAGES = [
  "jpg",
  "jpeg",
  "png",
  "gif",
  "tiff",
  "bmp",
  "heic",
  "heif",
  "webp",
];

export const ALLOW_DOCUMENTS = [
  "pdf",
  "rtf",
  "doc",
  "docx",
  "ppt",
  "pptx",
  "xls",
  "xlsx",
  "csv",
];

export const ALLOW_AUDIO = [
  "mp3",
  "wav",
  "aac",
  "flac",
  "m4a",
  "ogg",
  "weba",
  "opus",
];

export const UPLOAD_FILE_TYPES_DEFAULT = [
  ...ALLOW_COMPRESSED_FILES,
  ...ALLOW_VIDEO,
  ...ALLOW_IMAGES,
  ...ALLOW_DOCUMENTS,
  ...ALLOW_AUDIO,
];

/** Avatar uploads accept only web-safe raster formats the crop dialog can render. */
export const AVATAR_IMAGE_FILE_TYPES = ["jpg", "jpeg", "png", "gif"];
